module.exports = __webpack_public_path__ + "img/speaker-ErekleInashvili-imgs.3bebb4d3.png";